import React, { useState, useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/Shared/Navbar";
import Home from "./Pages/Home";
import Footer from "./Components/Shared/Footer";
import SignInModal from "./Pages/SignInModal";
import SignUpModal from "./Pages/SignUpModal";
import FemaleStyles from "./Pages/FemaleStyles";
import Product from "./Pages/Product";
import MaleStyles from "./Pages/MaleStyles";
import CustomizeForm from "./Pages/CustomizeForm";
// import OrderStyle from "./Components/Styles/OrderStyle";
import OrderDetails from "./Pages/OrderDetails";
import CartItem from "./Components/Add To Cart/CartItem";
import ForgetPassword from "./Pages/ForgetPassword";
import Laundry from "./Pages/Laundry";
import OtpInput from "./Components/Password/OtpInput";
import ResetPassword from "./Components/Password/ResetPassword";
import PasswordSuccessful from "./Components/Password/PasswordSuccessful";
import LaundryHistory from "./Pages/LaundryHistory";
import TailoringHistory from "./Pages/TailoringHistory";
import Contact from "./Pages/Contact";
import FAQ from "./Pages/FAQ";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import About from "./Pages/About";
import { TailoringProvider } from "./context/TailoringContext";
import { CartProvider } from "./context/CartContext";
import "react-toastify/dist/ReactToastify.css";
import UserContextProvider from "./context/userContext";
import MakeTailoringProvider from "./context/MakeTailoringContext";
import Success from "./Pages/Success";
import { LoaderProvider } from "./context/LoaderContext";
import { AddToCartProvider } from "./context/AddToCartContext";
import { CartModalProvider } from "./context/CartModalContext";
import CustomOrder from "./Components/CustomOrder/CustomOrder";
import CustomOrderSummary from "./Components/CustomOrder/CustomOrderSummary";

import jwt_decode from "jwt-decode";

function App() {
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [genderModal, setGenderModal] = useState(false);
  const [forgetPasswordModal, setForgetPasswordModal] = useState(false);
  const [otpInput, setOtpInput] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [passwordSuccessful, setPasswordSuccessful] = useState(false);

  const [editProfile, setEditProfile] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("_2mseamlessTailoring"));
    const token = userData?.token;

    if (token) {
      if (jwt_decode(token).exp < Date.now() / 1000) {
        localStorage.removeItem("_2mseamlessTailoring");
        setModalShow(true);
        window.location.reload()
      }
    }
  }, []);

  return (
    <>
      <UserContextProvider>
        <CartModalProvider>
          <TailoringProvider>
            <MakeTailoringProvider>
              <AddToCartProvider>
                <LoaderProvider>
                  <CartProvider>
                    <Navbar
                      {...{ setModalShow, setGenderModal, setEditProfile }}
                    />
                    <Routes>
                      <Route
                        exact
                        path="/"
                        element={<Home {...{ genderModal, setGenderModal }} />}
                      />
                      <Route
                        path="/tailoring"
                        element={<Home {...{ genderModal, setGenderModal }} />}
                      />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/faq" element={<FAQ />} />
                      <Route
                        path="/tailoring/femalestyle"
                        element={<FemaleStyles />}
                      />
                      <Route
                        path="/tailoring/malestyle"
                        element={<MaleStyles />}
                      />
                      <Route path="/tailoring/product" element={<Product />} />
                      <Route
                        path="/tailoring/customizeform"
                        element={<CustomizeForm />}
                      />
                      <Route
                        path="/tailoring/orderdetails"
                        element={<OrderDetails />}
                      />
                      <Route path="/cartitem" element={<CartItem />} />
                      <Route path="laundry" element={<Laundry />} />
                      <Route
                        path="/tailoring/customorder"
                        element={<CustomOrder />}
                      />
                      <Route
                        path="/tailoring/customordersummary"
                        element={<CustomOrderSummary />}
                      />
                      <Route
                        path="privacy-policy"
                        element={<PrivacyPolicy />}
                      />
                      <Route path="about" element={<About />} />
                      <Route path="success" element={<Success />} />
                      <Route
                        path="/laundry/laundryhistory"
                        element={
                          <LaundryHistory
                            {...{ editProfile, setEditProfile }}
                          />
                        }
                      />
                      <Route
                        path="/tailoring/tailoringhistory"
                        element={
                          <TailoringHistory
                            {...{ editProfile, setEditProfile }}
                          />
                        }
                      />
                    </Routes>
                    <Footer />

                    <SignInModal
                      {...{
                        modalShow,
                        setModalShow,
                        setModalShow2,
                        setForgetPasswordModal,
                      }}
                    />

                    <SignUpModal
                      {...{ modalShow2, setModalShow, setModalShow2 }}
                    />

                    <ForgetPassword
                      {...{
                        forgetPasswordModal,
                        setForgetPasswordModal,
                        setOtpInput,
                      }}
                    />

                    <OtpInput
                      {...{ otpInput, setOtpInput, setResetPassword }}
                    />

                    <ResetPassword
                      {...{
                        resetPassword,
                        setResetPassword,
                        setPasswordSuccessful,
                      }}
                    />

                    <PasswordSuccessful
                      {...{ passwordSuccessful, setPasswordSuccessful }}
                    />
                  </CartProvider>
                </LoaderProvider>
              </AddToCartProvider>
            </MakeTailoringProvider>
          </TailoringProvider>
        </CartModalProvider>
      </UserContextProvider>
    </>
  );
}

export default App;
